import {
  Navigate, useLocation,
} from 'react-router-dom'
import {
  APP_PATH_BY_DESTINATION,
} from '../utils/routes'

/**
 * `/settings`, which is what people call the page at /integrations.
 *
 * GET-18103's location-setup links named /settings, which matched no route and
 * rendered an empty page (GET-18882). Keeps the query and hash, which are the
 * whole of what a deep link asks for.
 */
export function SettingsAlias(): JSX.Element {
  const { search, hash } = useLocation()
  return <Navigate to={`${APP_PATH_BY_DESTINATION.settings.path}${search}${hash}`} replace />
}
